import React, { FC, useState } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useBmsBusSoDetailModel } from "../bmsBillBusSoModel";
import { Description } from "@/components/YhBox/Description";
import { useBmsSaleRoDetailModel } from "../../bmsBillSaleRo/bmsBillSaleRoModel"
import { Button } from 'antd';

export const TopButs: FC<RouterParamType> = () => {
    const { detailLookForm, } = useBmsBusSoDetailModel();
    const { getBmsTreeNodeName } = useBmsSaleRoDetailModel();
    const { selectedNavId, replaceNav, findNav, getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const goBack = () => {
        if (detailsInfo.parentInfo && detailsInfo.parentInfo.selectedNavId) {
            replaceNav(selectedNavId, detailsInfo.parentInfo.selectedNavId);
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>
    const orderStatus: IDescription[] = [
        {
            label: "销售单号",
            value: detailLookForm.saleCode ?? "暂无",
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: "状态",
            value: (detailLookForm?.status && getBmsTreeNodeName(detailLookForm?.status as string)) ?? "暂无",
            color: DescriptionColorEnum.green,
            status: true
        }
    ]

    return (
        <YhBox title={<>
            {orderStatus.map((item, index) => <Description key={index} {...item} />)}
        </>}
            action={action}
            style={{ paddingBottom: 0, marginBottom: "15px" }}
        />
    )
}